import { useEffect, useRef } from "react";
import { useRecoilState } from "recoil";
import { ToastContainer } from "react-toastify";

import "./App.css";
import "react-toastify/dist/ReactToastify.min.css";

import Footer from "./components/organisms/footer";
import FooterM from "./components/organisms/footerM";
import Header from "./components/organisms/header";
import HeaderM from "./components/organisms/headerM";
import useDisplay from "./hooks/useDisplay";

import Router from "./router/router";
import { headerMenuState } from "./store/headerState";
import ScrollToTop from "./util/scrollToTop";
import { errorHandler } from "./util/errorHandler";
import LectureApi from "./api/lecture.api";
import CommunityApi from "./api/community.api";
import ColumnApi from "./api/column.api";
import { route } from "./router/route";
import BaseInfoApi from "./api/baseInfo.api";

function App() {
  const { isMobile, isTablet, isDesktop } = useDisplay();
  const isSmall = isMobile || isTablet;
  // 방문자 등록
  const visitRequested = useRef(false);

  const [, setHeaderMenuStateAtom] = useRecoilState(headerMenuState);

  useEffect(() => {
    visitFunc();
    categoryListFunc();
  }, []);

  const visitFunc = async () => {
    try {
      if (visitRequested.current) {
        return;
      }
      visitRequested.current = true;
      await BaseInfoApi.visit();
    } catch (error) {
      visitRequested.current = false;
    }
  };

  const categoryListFunc = async () => {
    try {
      const requests = await Promise.allSettled([
        LectureApi.getCategoryList({
          page: 1,
          size: 0,
          lectureCategoryType: "FINANCE_STUDY",
          activation: "Active",
        }),
        LectureApi.getCategoryList({
          page: 1,
          size: 0,
          lectureCategoryType: "PAID_LECTURE",
          activation: "Active",
        }),
        ColumnApi.getCategoryList({
          page: 1,
          size: 0,
          activation: "Active",
        }),
        CommunityApi.getCategoryList({
          page: 1,
          size: 0,
          activation: "Active",
        }),
      ]);

      const getContent = (result) =>
        result.status === "fulfilled"
          ? (result.value.data.data.content ?? [])
          : [];
      const [studyCList, lectureCList, columnCList, communityCList] =
        requests.map(getContent);

      const categoryList = [
        {
          title: "금융 스터디",
          activation: true,
          src: `${route.study_list}`,
          childCategories: studyCList,
        },
        {
          title: "영상 강의",
          activation: true,
          src: `${route.lecture_list}`,
          childCategories: lectureCList,
        },
        {
          title: "금융 칼럼",
          activation: true,
          src: `${route.column_list}`,
          childCategories: columnCList,
        },
        {
          title: "커뮤니티",
          activation: true,
          src: `${route.community_list}`,
          childCategories: communityCList,
        },
      ];

      const dynamicTitles = new Set(categoryList.map((item) => item.title));
      setHeaderMenuStateAtom((current) => [
        ...categoryList,
        ...current.filter((item) => !dynamicTitles.has(item.title)),
      ]);

      const failedRequest = requests.find(
        (result) => result.status === "rejected",
      );
      if (failedRequest) errorHandler(failedRequest.reason);
    } catch (error) {
      errorHandler(error);
    }
  };

  return (
    <>
      <ScrollToTop />

      {isSmall ? <HeaderM /> : <Header />}

      <Router />

      {isSmall ? <FooterM /> : <Footer />}

      <ToastContainer
        className="toast"
        position="top-center"
        autoClose={2000}
        hideProgressBar={true}
      />
    </>
  );
}

export default App;
